module.exports = __webpack_public_path__ + "img/aliex2.d1cc1ec2.jpg";